import * as React from 'react';

import { FacilityRecord } from '@rematter/modules/facilities/types/facility';
import { Button, DataGridColumn } from '@rematter/ui-web';

import { useTranslations } from '@/facilities/i18n/useTranslations';

type UseFacilitiesColumnsArgs = {
  onEdit?: (row: FacilityRecord) => void;
};

export const useFacilitiesColumns = ({
  onEdit,
}: UseFacilitiesColumnsArgs = {}): DataGridColumn<FacilityRecord>[] => {
  const t = useTranslations();

  return React.useMemo(() => {
    const columns: DataGridColumn<FacilityRecord>[] = [
      {
        key: 'name',
        header: t.facilities.list.columns.name,
        width: 250,
        cell: ({ row }) => row.facilityName,
      },
      {
        key: 'type',
        header: t.facilities.list.columns.type,
        width: 200,
        cell: ({ row }) => row.facilityType,
      },
      {
        key: 'group',
        header: t.facilities.list.columns.group,
        width: 200,
        cell: ({ row }) => row.facilityGroup?.name ?? '-',
      },
      {
        key: 'actions',
        header: '',
        width: 200,
        cell: ({ row }) => (
          <div className="flex gap-2">
            <Button
              color="primary"
              className="grow border border-primary/40 shadow-sm shadow-neutral/10"
              onPress={() => onEdit?.(row)}
              size="small"
            >
              {t.facilities.list.actions.viewDetails}
            </Button>
          </div>
        ),
      },
    ];
    return columns;
  }, [t, onEdit]);
};
